import styled from 'styled-components'

const MyDiv = styled.div`
.page_wrapper {
     padding-top: 8px;
  }
 
  .page_heading {
    margin-bottom: 16px;
  }
 
  .flex_header {
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
  }
 
  .filter_section {
    display: flex;
    gap: 10px;
  }
 
  .icon_btn {
    min-width: 40px;
    cursor: pointer;
   
  }
.view{
  text-decoration: underline;
  color: #006838;
  cursor: pointer;
  }
 .empId {
    text-decoration: underline;
    color: rgba(0, 122, 255, 1);
    display: inline-flex;
    align-items: center;
    padding: 4px 8px; 
    border-radius: 16px;
    cursor: pointer;
    white-space: nowrap; 
  }
  .status_badge {
    padding: 3px 6px;
    font-size: 12px;
    border-radius: 4px;
    font-weight: 500;
    font-family: 'Poppins', sans-serif;
    display: inline-block;
  }

  .status_badge.green {
    background-color: #dcfce7;
    color: #15803d;
  }

  .status_badge.red {
    background-color: #fee2e2;
    color: #b91c1c;
  }

  .status_badge.orange {
    background-color: #fff7ed;
    color: #c2410c;
  }

  .status_badge.blue {
    background-color: #e0f2fe;
    color: #0369a1;
  }

  .status_badge.purple {
    background-color: #ede9fe;
    color: #6d28d9;
  }
    
  .status_badge.pink {
    background-color: #ede9fe;
    color: #b4288aff;
  }
  .status_badge.yellow {
    background-color: #e7e6e1ff;
    color: #f4ca0eff;
  }

  .status_badge.cyan {
  background-color: #e0f7faff;
  color: #00bcd4; 
  
  
.status_badge.teal {
  background-color: #ccfbf1;
  color: #0f766e;
}

.status_badge.amber {
  background-color: #fef3c7;
  color: #b45309;
}

}
`
export default MyDiv